import {makeStyles, Theme} from "@material-ui/core/styles";
import {Box, createStyles, Typography} from "@material-ui/core";
import React, {RefObject, useEffect} from "react";
import Slider from "@material-ui/core/Slider";

const useSectionLoopingStyles = makeStyles((_: Theme) => createStyles({
  valueLabel: {top: 22, '& *': {background: 'transparent', color: '#000'}},
  thumb: {zIndex: 1},
  barContainer: {position: 'relative'},
  barCover: {position: 'absolute', top: -20, height: 2, display: 'block', background: '#b7bde3'}
}));
/**
 * A controller for specific section loop. Subject may control the section they wanna loop
 */
export const AudioSectionLoopingController = function ({audioRef, currentTime, range, onRangeChange, setTimeUpdate}: { audioRef: RefObject<HTMLAudioElement>, currentTime: number, range?: number[], onRangeChange: (range: number[]) => void, setTimeUpdate: (_: () => void) => void}) {
  const primary = audioRef;
  const classes = useSectionLoopingStyles();
  useEffect(() => {
    // Initialize the shared loop range only once. It must survive clip changes.
    if (!range && primary?.current?.duration) onRangeChange([0, primary.current.duration]);
  }, [onRangeChange, primary, range]);
  // Return update methods for parent component
  useEffect(() => setTimeUpdate(() => {
    if (range && (currentTime < range[0] || currentTime > range[1]))
      if (audioRef.current) audioRef.current.currentTime = range[0]
  }));

  // When drag the slider bar
  const handleChange = (_: any, newValue: number | number[]) => {
    const newRanges = newValue as number[]
    // If the current time is out of range
    if (currentTime < newRanges[0] || currentTime > newRanges[1])
      if (audioRef.current) audioRef.current.currentTime = newRanges[0]
    onRangeChange(newRanges);
  }
  const handleSliderLabelFormat = (num: number) => {
    return isNaN(num) ? 0 : num.toFixed(0) + 's'
  }

  return <Box className={classes.barContainer}>
    <Typography>Section Looping Controls</Typography>
    <Slider classes={{thumb: classes.thumb, valueLabel: classes.valueLabel}} valueLabelDisplay="auto"
            value={range || [0, 0]} aria-labelledby="range-slider" step={0.1} max={primary.current?.duration}
            valueLabelFormat={handleSliderLabelFormat} onChange={handleChange}/>
    <span className={classes.barCover} style={{
      // Calculate cover bar of styles every rendering
      left: 0, width: (range ? range[0] : 0) / primary.current?.duration * 100 + '%'
    }}/>
  </Box>
}
